import App from 'app/app.js';
import 'app/action/SessionTimeoutAction.js';
import '@app/action/SessionRecreatedAction.js';
import { isSessionTimeoutStatus } from '@app/interceptor/interceptor-logic';

function SessionTimeoutInterceptor(
  $q,
  $injector,
  SessionTimeoutAction,
  SessionRecreatedAction,
  SessionTimeoutService,
  StorageService
) {
  return {
    responseError: function (rejection) {
      if (isSessionTimeoutStatus(rejection.status) && !SessionTimeoutService.isPendingSessionTimeout()) {
        SessionTimeoutService.setPendingSessionTimeout(true);

        SessionTimeoutAction.dispatch();

        StorageService.resetServer().finally(function () {
          const UserProfileStore = $injector.get('UserProfileStore');
          SessionRecreatedAction.dispatch();
          UserProfileStore.loadIdentityUser();
        });
      }
      return $q.reject(rejection);
    }
  };
}

App.factory('SessionTimeoutInterceptor', [
  '$q',
  '$injector',
  'SessionTimeoutAction',
  'SessionRecreatedAction',
  'SessionTimeoutService',
  'StorageService',
  SessionTimeoutInterceptor
]);
App.config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('SessionTimeoutInterceptor');
  }
]);
